var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGobblerno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    fill: "white",
    stroke: "#FF2E2E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1226_1539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.32 11.0003L14.7949 8.52535C15.0683 8.2519 15.0683 7.80856 14.7949 7.53553L14.465 7.20561C14.1914 6.9321 13.7481 6.9321 13.4751 7.20561L11.0003 9.68046L8.52535 7.20509C8.2519 6.93164 7.80856 6.93164 7.53553 7.20509L7.20509 7.53505C6.93164 7.80858 6.93164 8.25193 7.20509 8.52494L9.68041 11.0003L7.20559 13.4751C6.93207 13.7486 6.93207 14.192 7.20559 14.465L7.53553 14.7949C7.80898 15.0684 8.25232 15.0684 8.52535 14.7949L11.0002 12.32L13.4751 14.7949C13.7486 15.0684 14.192 15.0684 14.465 14.7949L14.7949 14.465C15.0684 14.1914 15.0684 13.7481 14.7949 13.4751L12.32 11.0003Z",
    fill: "#FF2E2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1226_1539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGobblerno);
export default __webpack_public_path__ + "static/media/gobblerno.ee34c94e7dc9ec57f7570b30b6e62ac1.svg";
export { ForwardRef as ReactComponent };